<template>
  <component
    :is="componentType"
    class="dea-event__link"
    :class="`${columns} dea-event__link--${cardModifier}`"
    :href="event.detail_url"
    @click.stop="goto"
  >
    <div class="dea-event" :class="`dea-event--${cardModifier}`">
      <div v-if="isCardLayout" class="dea-event__badge-container dea-heading--medium__xm" :class="badgeClass">
        {{ event.type_label }}
      </div>
      <div v-else :class="{ 'dea-event__upper-box': hasMobileAccordion }">
        <div>
          <Badge :class="badgeClass">{{ event.type_label }}</Badge>
          <div
            v-if="hasMobileAccordion && !isAccordionToggled && !isDesktopView"
            class="dea-event__title dea-event__mobile-accordion"
          >
            <Links
              v-if="!event.detail_url && event.event_url"
              :href="event.event_url"
              target="_blank"
              class="dea-links--no-border"
            >
              <div class="dea-event__title dea-heading--medium__ml">{{ event.title }}</div>
            </Links>
          </div>
        </div>
        <div v-if="hasMobileAccordion && !isDesktopView" class="dea-event__mobile-accordion">
          <i
            v-if="!isAccordionToggled"
            class="dea-ico-freccia-down dea-event__accordion-button"
            @click="isAccordionToggled = !isAccordionToggled"
          ></i>
          <i
            v-if="isAccordionToggled"
            class="dea-ico-freccia-up dea-event__accordion-button"
            @click="isAccordionToggled = !isAccordionToggled"
          ></i>
        </div>
      </div>
      <div
        class="dea-event__content"
        :class="[
          `dea-event__content--${cardModifier}`,
          { 'dea-event__content--hidden': hasMobileAccordion && !isAccordionToggled && !isDesktopView },
        ]"
      >
        <div class="dea-event__infos-container" :class="`dea-event__infos-container--${cardModifier}`">
          <div class="dea-event__group-label dea-heading--medium__xm">{{ stateLabel }}</div>
          <div class="dea-event__title-container" :class="`dea-event__title-container--${cardModifier}`">
            <Links
              v-if="!event.detail_url && event.event_url"
              :href="event.event_url"
              target="_blank"
              class="dea-links--no-border"
            >
              <div
                class="dea-event__title"
                :class="[
                  { 'dea-heading--medium__m': !isActiveCard, 'dea-heading--medium__l': isActiveCard },
                  `dea-event__title--${cardModifier}`,
                ]"
              >
                {{ event.title }}
              </div>
            </Links>
            <div
              v-else
              class="dea-event__title"
              :class="[
                { 'dea-heading--medium__m': !isActiveCard, 'dea-heading--medium__l': isActiveCard },
                `dea-event__title--${cardModifier}`,
              ]"
            >
              {{ event.title }}
            </div>
          </div>
          <div v-if="!naked && !isTicketLayout" class="dea-event__event-price dea-heading--medium__s">
            <EventPrice
              v-if="!priceItem.free"
              :regular-price="parseFloat(priceItem.regular_price)"
              :sale-price="parseFloat(priceItem.sale_price)"
            ></EventPrice>
          </div>
          <div v-if="!naked" class="dea-event__info">
            <template v-if="(event.skip_legs || registration || event.legs.length === 1) && main_leg">
              <div v-if="main_leg.start_date_fmt && main_leg.type != 'online-course'" class="dea-heading--regular__ms">
                {{ main_leg.day }}, {{ main_leg.start_date_fmt }}
              </div>
              <div v-else class="dea-heading--regular__ms">{{ main_leg.day }}&nbsp;</div>
              <div v-if="main_leg.city" class="dea-event__city dea-heading--light__xs">{{ main_leg.city }}</div>
              <div v-if="main_leg.near" class="dea-event__near-event dea-heading--medium__xs">Vicino a te!</div>
              <div
                v-else-if="
                  main_leg.speakers &&
                  main_leg.speakers.length &&
                  (event.event_mode == 'digital' || event.event_type == 'seminar')
                "
                class="dea-event__speaker dea-heading--light__xs"
              >
                <b>con:</b>
                {{ main_leg.speakers[0].fullname }}
              </div>
            </template>
            <template v-else-if="event.type === 'convention'">
              <template v-if="event.main_leg">
                <div class="dea-heading--regular__ms">{{ main_leg.day }}, {{ main_leg.start_date_fmt }}</div>
                <div v-if="main_leg.city" class="dea-event__city dea-heading--light__xs">{{ main_leg.city }}</div>
                <div v-if="main_leg.near" class="dea-event__near-event dea-heading--medium__xs">Vicino a te!</div>
              </template>
              <template v-else-if="0 < legs.length && legs.length < 6">
                <div v-if="legs.length === 1" class="dea-heading--regular__ms">{{ legs.length }} tappa disponibile</div>
                <div v-else-if="legs.length > 1" class="dea-heading--regular__ms">
                  {{ legs.length }} tappe disponibili
                </div>
                <span
                  v-for="(leg, index) in legs"
                  :key="`${leg.city}-${index}`"
                  class="dea-event__city dea-event__city--list dea-heading--light__xs"
                  >{{ leg.city }}</span
                >
              </template>
              <div v-else-if="legs.length > 5" class="dea-heading--regular__ms">
                {{ legs.length }} tappe disponibili
              </div>
              <div v-if="event.near" class="dea-event__near-event dea-heading--medium__xs">Vicino a te!</div>
            </template>
            <template v-else-if="event.type === 'seminar'">
              <template v-if="false">
                <template v-if="event.main_leg">
                  <div v-if="main_leg.day" class="dea-heading--regular__ms">
                    {{ main_leg.day }}, {{ main_leg.start_date_fmt }}
                  </div>
                  <div v-if="main_leg.city" class="dea-event__city dea-heading--light__xs">{{ main_leg.city }}</div>
                  <div v-if="main_leg.near" class="dea-event__near-event dea-heading--medium__xs">Vicino a te!</div>
                </template>
              </template>
              <div class="dea-heading--regular__ms">&nbsp;</div>
              <div v-if="event.speakers.length" class="dea-event__speaker dea-heading--light__xs">
                <b>con:</b>
                {{ event.speakers[0].fullname }}
              </div>
            </template>
            <template v-else-if="event.type === 'attended_event'">
              <div v-if="main_leg.day" class="dea-heading--regular__ms">{{ main_leg.day }}</div>
              <div v-if="main_leg.city" class="dea-event__city dea-heading--light__xs">{{ main_leg.city }}</div>
              <div v-if="main_leg.near" class="dea-event__near-event dea-heading--medium__xs">Vicino a te!</div>
            </template>
            <template v-else-if="event.type === 'webinar'">
              <div class="dea-heading--regular__ms">
                <template v-if="main_leg && main_leg.day"> {{ main_leg.day }}, {{ main_leg.start_date_fmt }} </template
                >&nbsp;
              </div>
              <div v-if="event.speakers.length" class="dea-event__speaker dea-heading--light__xs">
                <b>con:</b>
                {{ event.speakers[0].fullname }}
              </div>
            </template>
            <template v-else-if="event.type === 'online-course'">
              <template v-if="false">
                <div class="dea-heading--regular__ms">{{ main_leg.day }}&nbsp;</div>
              </template>
              <div v-if="event.speakers.length" class="dea-event__speaker dea-heading--light__xs">
                <b>con:</b>
                {{ event.speakers[0].fullname }}
              </div>
            </template>
            <template v-else-if="event.type === 'video-lesson'">
              <div class="dea-heading--regular__ms">&nbsp;</div>
              <div v-if="event.speakers.length" class="dea-event__speaker dea-heading--light__xs">
                <b>con:</b>
                {{ event.speakers[0].fullname }}
              </div>
            </template>
          </div>
          <div v-if="naked" class="dea-event__description dea-heading--regular__ms">{{ event.description }}</div>
          <template v-if="!isDisabledCard">
            <div class="dea-event__card-footer dea-heading--regular__s">
              <div v-if="isCardLayout && actionsEnabled" class="dea-event__card-footer--social-icons">
                <button class="dea-card-resource__button dea-ico-share"></button>
                <button class="dea-card-resource__button dea-ico-bookmark"></button>
              </div>
            </div>
          </template>
        </div>
        <div v-if="!isDisabledCard && !isTicketLayout" class="dea-event__icons-container">
          <svg-icon
            v-for="(icon, key) in event.categories"
            :key="key"
            class="dea-event__icon dea-border-grey-medium-light"
            :name="`formazione/${icon.icon}`"
            :aria-label="icon.name"
          />
          <div v-if="event.event_subject" class="dea-event__subject dea-heading--regular__xm">
            {{ event.event_subject }}
          </div>
        </div>
      </div>
    </div>
  </component>
</template>

<script>
import Badge from "@/components/elements/Badge";
import EventPrice from "@/components/elements/EventPrice";
import Links from "@/components/elements/Links";
import HandleWindowResize from "@/components/mixins/handleWindowResize";
import SvgIcon from "@/components/elements/SvgIcon";
import variables from "@/styles/variables.scss";

export default {
  name: "CardEvent",
  status: "ready",
  release: "1.0.0",
  components: {
    Badge,
    EventPrice,
    Links,
    SvgIcon,
  },
  mixins: [HandleWindowResize],
  props: {
    event: {
      type: Object,
      required: true,
    },
    registration: {
      type: Object,
      default: () => {},
    },
    legs: {
      type: Array,
      required: true,
    },
    cardLayout: {
      type: String,
      required: true,
    },
    columns: {
      type: String,
      default: "xs-3",
    },
    deleted: {
      type: Boolean,
      default: false,
    },
    onHold: {
      type: Boolean,
      default: false,
    },
    actionsEnabled: {
      type: Boolean,
      default: false,
    },
    hasMobileAccordion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isAccordionToggled: false,
    };
  },
  computed: {
    priceItem() {
      if (this.registration) return this.registration;
      if (this.main_leg && parseFloat(this.main_leg.regular_price)) return this.main_leg;
      return this.event;
    },
    componentType() {
      if (this.cardUrl) return "a";
      return "span";
    },
    cardUrl() {
      return this.isCardLayout ? this.event.detail_url : "";
    },
    main_leg() {
      if (this.registration) {
        return this.registration.linked_event;
      }
      if (this.event.main_leg) {
        return this.event.main_leg;
      }
      if (this.legs && this.legs.length) {
        return this.legs[0];
      }
      return this.event;
    },
    badgeClass() {
      if (!this.isDisabledCard) {
        return this.event.bgMod;
      }
      return `${this.event.bgMod} dea-event--disabled`;
    },
    stateLabel() {
      if (this.event.group) return this.event.group.name;
      if (this.deleted) return "Cancellato";
      if (this.on_hold) return "In attesa";
      return "";
    },
    cardModifier() {
      const modifier = {
        card: "base",
        shoppingCart: "cart",
        active: "cart dea-event--cart-active",
        disabled: "cart dea-event--cart-disabled",
        ticket: "card-ticket",
      };
      return modifier[this.cardLayout];
    },
    isCardLayout() {
      return this.cardLayout === "card";
    },
    isActiveCard() {
      return this.cardLayout === "active";
    },
    isDisabledCard() {
      return this.cardLayout === "disabled";
    },
    isTicketLayout() {
      return this.cardLayout === "ticket";
    },
    naked() {
      let naked =
        !this.event.main_leg &&
        (this.priceItem.free || Number(this.priceItem.regular_price) === 0) &&
        this.event.event_type !== "video-lesson" &&
        this.event.speakers.length === 0 &&
        !this.event.city &&
        !this.event.day;
      if (this.event.type !== "video-lesson") naked = naked && !this.event.skip_legs;
      return naked;
    },
    isDesktopView() {
      return this.windowWidth > variables.bpSizeMedium;
    },
  },
  methods: {
    goto() {
      if (this.componentType === "a") document.url = this.cardUrl;
    },
    isMobile(value) {
      return value === "mobile";
    },
    isDesktop(value) {
      return value === "desktop";
    },
    isApp(value) {
      return value === "app";
    },
    isEvent(value) {
      return value === "event";
    },
  },
};
</script>

<style lang="scss"></style>
